import {useCallback} from 'react';

import {ChemistryPreferences} from 'chemistry/ChemistryConstants';
import {ChemSearchSubmit, ChemSearchSubmitResult} from 'chemistry/chemSearchSubmit';
import {ToggleHighlightParams} from 'chemistry/ChemSearchUtils';
import preferences from 'Preferences';
import {ChemicalStructureSearchOperator} from 'search/SearchConstants';

interface UseChemSearchModalSubmitArgs {
  toggleHighlightParams: ToggleHighlightParams;
  highlightChecked: boolean;
  chemSearchOperator: ChemicalStructureSearchOperator;
  onRequestSubmit: (submit: ChemSearchSubmit | null) => void;
  buildSubmitResult: () => ChemSearchSubmitResult;
}

interface UseChemSearchModalSubmitResult {
  handleSubmit: () => void;
}

export function useChemSearchModalSubmit({
  toggleHighlightParams,
  highlightChecked,
  chemSearchOperator,
  onRequestSubmit,
  buildSubmitResult,
}: UseChemSearchModalSubmitArgs): UseChemSearchModalSubmitResult {
  const handleSubmit = useCallback((): void => {
    const result = buildSubmitResult();
    if (toggleHighlightParams.showToggleHighlightOption) {
      toggleHighlightParams.setShouldHighlightSubstructure(highlightChecked);
    }
    preferences.set(ChemistryPreferences.CHEM_SEARCH_TYPE, chemSearchOperator);
    if (result.minSimilarityToSave != null) {
      preferences.set(ChemistryPreferences.MIN_SIMILARITY, result.minSimilarityToSave);
    }
    onRequestSubmit(result.submit);
  }, [buildSubmitResult, chemSearchOperator, highlightChecked, onRequestSubmit, toggleHighlightParams]);

  return {handleSubmit};
}
